let BASE_URL = window?.extended?.SERVICES_ROOT_URL;

if (!BASE_URL) {
    BASE_URL = "https://external.api.bnpparibasfortis.be"
}

export {BASE_URL};
//
